import React, { useState } from "react";
import {
  FileText,
  Layout,
  ListTree,
  ShieldCheck,
  RefreshCw,
} from "lucide-react";

const SyncButton = ({ title, icon, onSync, colorClass = "blue" }) => {
  const [isSyncing, setIsSyncing] = useState(false);

  const handleAction = async (e) => {
    e.stopPropagation();
    if (isSyncing) return;

    setIsSyncing(true);
    try {
      await onSync();
    } catch (error) {
      console.error(`Sync failed for ${title}:`, error);
    } finally {
      setIsSyncing(false);
    }
  };

  return (
    <div
      onClick={handleAction}
      className="group relative flex flex-col items-start p-5 bg-white border border-slate-200 rounded-xl hover:border-blue-500 hover:shadow-lg transition-all cursor-pointer overflow-hidden"
    >
      <div className="flex justify-between items-start w-full mb-4">
        <div
          className={`p-2.5 rounded-lg transition-colors ${
            colorClass === "blue"
              ? "bg-blue-50 text-blue-600 group-hover:bg-blue-600 group-hover:text-white"
              : "bg-indigo-50 text-indigo-600 group-hover:bg-indigo-600 group-hover:text-white"
          }`}
        >
          {icon}
        </div>

        <button
          disabled={isSyncing}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-[10px] font-bold uppercase tracking-wider transition-all shadow-sm ${
            isSyncing
              ? "bg-orange-100 text-orange-600 cursor-wait"
              : "bg-slate-100 text-slate-600 group-hover:bg-blue-600 group-hover:text-white"
          }`}
        >
          <RefreshCw size={12} className={isSyncing ? "animate-spin" : ""} />
          {isSyncing ? "Syncing..." : "Sync Now"}
        </button>
      </div>

      <div className="space-y-1 relative z-10">
        <h3 className="text-sm font-bold text-slate-700 group-hover:text-blue-600">
          {title}
        </h3>
      </div>
    </div>
  );
};

const CloudSync = () => {
  const DEPARTMENT =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  const CURRENT_USER = localStorage?.getItem("currentUserName") || "admin";
  const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : "";
  const VATPERCENTAGE = CURRENT_USER_OBJECT[0]?.vatp;
  const USER_ACCESS = CURRENT_USER_OBJECT[0]?.useraccess;
  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";

  console.log("User Access", USER_ACCESS);
  const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

  const handleSyncProcess = async (mode) => {
    try {
      // 1. GET data from SyncUtility
      const response = await fetch(
        `${BASE_URL}/api/CRMSyncUtility/${mode}/${COMPANY_CODE}`,
      );
      if (!response.ok) throw new Error("Failed to fetch sync data");

      const data = await response.json();

      if (data && data.length > 0) {
        const postResponse = await fetch(`${BASE_URL}/api/CRMSyncReg`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        if (!postResponse.ok) throw new Error("Failed to post sync data");
        console.log(`${mode} synced successfully`);
      } else {
        console.warn(`No data found for mode: ${mode}`);
      }
    } catch (err) {
      alert(`Sync Error: ${err.message}`);
      throw err; // Re-throw to let the button handle the 'finally' block
    }
  };

  const syncItems = [
    {
      title: "Access Master Sync",
      mode: "ACCESSMASTER",
      icon: <ShieldCheck size={20} />,
      color: "blue",
    },
    {
      title: "Screen GL Sync",
      mode: "SCREENGL",
      icon: <Layout size={20} />,
      color: "blue",
    },
    {
      title: "Voucher Master Sync",
      mode: "VOUCHERMASTER",
      icon: <FileText size={20} />,
      color: "blue",
    },
    {
      title: "GL Category Master Sync",
      mode: "GLCATEGORY",
      icon: <ListTree size={20} />,
      color: "indigo",
    },
  ];

  return (
    <div className="p-4 space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {syncItems.map((item, idx) => (
          <SyncButton
            key={idx}
            title={item.title}
            icon={item.icon}
            colorClass={item.color}
            onSync={() => handleSyncProcess(item.mode)}
          />
        ))}
      </div>
    </div>
  );
};

export default CloudSync;
